import styled from "styled-components";

/** Detail rows stack flush — each row carries its own bottom border. */
export const RowStack = styled.div`
  display: flex;
  flex-direction: column;
`;
